"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FileUpload = _interopRequireDefault(require("./FileUpload"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var FileUploadBuilder = function FileUploadBuilder(_ref) {
  var id = _ref.id,
      acceptMultiple = _ref.acceptMultiple;
  return /*#__PURE__*/_react.default.createElement(_FileUpload.default, {
    id: id,
    acceptMultiple: acceptMultiple,
    disabled: true
  });
};

FileUploadBuilder.propTypes = {
  /** The unique identifier of the question */
  id: _propTypes.default.string.isRequired,

  /** Indicates whether multiple files can be uploaded in the response */
  acceptMultiple: _propTypes.default.bool.isRequired
};
var _default = FileUploadBuilder;
exports.default = _default;